import React, {useEffect, useRef} from 'react';
import { NavLink, Redirect } from 'react-router-dom';
const SampleTabLinks = ({togglePrimary, language, primaryCount = 0, secondaryCount = 0}) => {
    const {secondary,primary} = language;
    const ref=useRef(null);
    return (
        <div className="nav-links-left">
            {secondaryCount === 0 && primaryCount !== 0?<Redirect to="/samples/primary"/>:""}
            {secondaryCount > 0 ? <NavLink id="secondary" onClick={togglePrimary} exact to="/samples">{secondary}</NavLink>:""}
            {primaryCount> 0 ? <NavLink ref={ref} id="primary" onClick={togglePrimary} to="/samples/primary">{primary}</NavLink>:""}
        </div>
    )
}
export default SampleTabLinks
